import React, { Component, useEffect } from 'react';
import { isFunction } from 'lodash';
import OptionField from '../OptionField';
import InfoBox from '../../ShadeForm/InfoBox';
import CoupledShadeTable from '../../NewItems/CoupledShadeTable';

class ShadeFormOptions extends Component {
	constructor(props) {
		super(props);
		this.state = {
			inside_fabric: false,
			outside_fabric: false,
			inside_roll: false,
			outside_roll: false,
			fabrics: [],
		};

		this.changed = this.changed.bind(this);
		this.blurred = this.blurred.bind(this);
	}

	changed(...args) {
		this.props.onChange(args);
		this.props.onOptionChange();
	}

	blurred(arg) {
		this.forceUpdate();
		this.props.checkErrors();
		this.props.onOptionChange();
		// setShadeHash(hash(shade.savableObject()));

		// props.onOptionBlur && props.onOptionBlur(arg);
	}


	render() {
		const {
			quote, shade, quoteData, quoteType
		} = this.props;

		const { shadeHash } = this.state;

		const {
			store
		} = quoteData.quoteLevelVariables()

		const self = this;
		const storeState = store.getState();


		const isIndoorFabric = (fabric) => fabric.is_indoor;
		const isOutdoorFabric = (fabric) => fabric.is_outdoor;
		const isOutdoor =  shade.isOutdoor();

		const unlocked = shade.isUnlocked();
		const fabs = storeState.entity.fabrics.list.filter(isOutdoor ? isOutdoorFabric : isIndoorFabric);

		const fields = [];

		let current_group = [];
		let current_group_name = '';
		let last_opt;
		let i = 0;

		let form_group_z_index = 80;

		const { state } = this;

		const setState = (goods) => this.setState({ ...state, ...goods });

		// This is for state and display for hovering pictures
		const getInsideFabricState = () => state.inside_fabric;
		const getOutsideFabricState = () => state.outside_fabric;
		const getInsideRollState = () => state.inside_roll;
		const getOutsideRollState = () => state.outside_roll;

		const toggleInsideFabricState = (override) => setState({ inside_fabric: override != null ? override : !(state.inside_fabric ?? false) });
		const toggleOutsideFabricState = (override) => setState({ outside_fabric: override != null ? override : !(state.outside_fabric ?? false) });
		const toggleInsideRollState = (override) => setState({ inside_roll: override != null ? override : !(state.inside_roll ?? false) });
		const toggleOutsideRollState = (override) => setState({ outside_roll: override != null ? override : !(state.outside_roll ?? false) });

		const injectedMethods = {
			getInsideFabricState,
			getOutsideFabricState,
			getInsideRollState,
			getOutsideRollState,
			toggleInsideFabricState,
			toggleOutsideFabricState,
			toggleInsideRollState,
			toggleOutsideRollState,
		};

		shade.options(injectedMethods)
			.filter((opt) => opt.showOnForm || opt.showOnForm == null)
			.forEach((option) => {
				const opt_group_name = isFunction(option.groupName) ? option.groupName(shade) : option.groupName;
				option.value = (option.getValue && option.getValue(shade)) || shade.val(option.varName);
				option.shade = shade;

				const disabled = !(option.skipReprice || unlocked);

				if (!option.conditional || option.conditional(shade)) {
					if (option.varName == 'coupledShades') {
						if (current_group.length > 0) {
							fields.push(

								<div
									key={`form-group-${current_group_name}`}
									className={`form-group no-bottom ${last_opt.inlineGroup ? 'inline-group ' : ''}${{ current_group_name }}`}
									style={{ zIndex: form_group_z_index-- }}
								>
									<span className={`form-group-title text-${quoteType}`}>{current_group_name}</span>
									{current_group}
								</div>
							);
						}

						current_group = [];
						current_group_name = '';

						current_group_name = opt_group_name;

						const widthOption = shade.options().find((o) => o.varName == 'width');

						current_group.push(
							<CoupledShadeTable
								quoteType={quoteType}
								disabled={disabled}
								key="coupled"
								shadeAssembly={shade}
								option={option}
								update={this.blurred}
								widthOption={widthOption}
							/>
						);

						current_group_name = opt_group_name;
					} else if (!opt_group_name) {
						if (current_group.length > 0) {
							fields.push(

								<div key={`form-group-${current_group_name}`} className={`${formy} no-bottom${last_opt.inlineGroup ? 'inline-group' : ''} ${current_group_name}`} style={{ zIndex: form_group_z_index-- }}>
									<span className={`form-group-title text-${quoteType}`}>{current_group_name}</span>
									{current_group}
								</div>
							);
						}

						current_group = [];
						current_group_name = '';

						fields.push(
							<OptionField
								quoteType={quoteType}
								disabled={disabled}
								key={`${option.varName}-${option.value}`}
								option={option}
								onBlur={this.blurred}
								quote={quote}
								value={option.value ?? null}
								shade={shade}
								onChangeTwo={this.changed}
								id={option.getId(option.shade.data())}
								choices={fabs}
							/>
						);

						if (option.info != null && option.info(shade) != null) {
							fields.push(
								<InfoBox quoteType={quoteType} key={`info-box-${option.varName}`} message={option.info(shade)} />
							);
						}
					} else if (opt_group_name != current_group_name) {
						if (current_group.length > 0) {
							let formy = "form-group";
							if (current_group_name == "Coupled Shades") {
								formy = "";
							}
							fields.push(

								<div
									key={`form-group-${current_group_name}`}
									className={`${formy} no-bottom ${last_opt.inlineGroup ? 'inline-group' : ''} ${current_group_name}`}
									style={{ zIndex: form_group_z_index-- }}
								>
									<span className={`form-group-title text-${quoteType}`}>{current_group_name}</span>
									{current_group}
								</div>
							);
						}

						current_group = [];
						current_group_name = '';

						current_group_name = opt_group_name;

						current_group.push(

							<OptionField
								quoteType={quoteType}
								disabled={disabled}
								key={`${option.varName}-${option.value}`}
								option={option}
								onFocus={this.props.setFocusedOption}
								onBlur={this.blurred}
								quote={quote}
								value={option.value ?? null}
								shade={shade}
								onChangeTwo={this.changed}
								id={option.getId(option.shade.data())}
								choices={fabs}
                                
							/>
						);

						if (option.info != null && option.info(shade) != null) {
							current_group.push(
								<InfoBox quoteType={quoteType} message={option.info(shade)} />
							);
						}
					} else {
						current_group_name = opt_group_name;

						if (option.info != null && option.info(shade) != null) {
							current_group.push(
								<div className="info-box-lucy-outer">
									<OptionField
										quoteType={quoteType}
										disabled={disabled}
										key={`${option.varName}-${option.value}`}
										option={option}
										onFocus={this.props.setFocusedOption}
										onBlur={this.blurred}
										quote={quote}
										value={option.value ?? null}
										shade={shade}
										id={option.getId(option.shade.data())}
										onChangeTwo={this.changed}
										choices={fabs}
										extraClassStyles="flex-grow-1 be-wider "
									/>
									<div className="info-box-lucy">
										<InfoBox message={option.info(shade)} />
									</div>
								</div>

							);
						} else {
							current_group.push(
								<OptionField
									quoteType={quoteType}
									disabled={disabled}
									key={`${option.varName}-${option.value}`}
									option={option}
									onFocus={this.props.setFocusedOption}
									onBlur={this.blurred}
									quote={quote}
									value={option.value ?? null}
									shade={shade}
									id={option.getId(option.shade.data())}
									choices={fabs}
									onChangeTwo={this.changed}
								/>
							);
						}
					}
				}
				const a = 431;

				last_opt = option;

				i++;
			});

		if (current_group.length > 0) {
			fields.push(

				<div
					key={`form-group-${current_group_name}`}
					className={`form-group no-bottom ${(last_opt && last_opt.inlineGroup) ? 'inline-group ' : ''}${{ current_group_name }}`}
					style={{ zIndex: form_group_z_index-- }}
				>
					<span className={`form-group-title text-${quoteType}`}>{current_group_name}</span>
					{current_group}

				</div>
			);
		}

		return fields;
	}
}

export default ShadeFormOptions;
